import React, { useEffect, useMemo, useState } from 'react';

import Box from '@mui/material/Box';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';

import Drawer from '../shared/Drawer';
import Autocomplete from '../shared/Autocomplete';
import Button from '../shared/Button';

import { userRoles } from '../../constants';

const FilterHospitalsModal = (props) => {
  const {
    filter,
    open,
    onSubmit,
    onClose,
    companies,
    currentUser,
  } = props;

  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  useEffect(() => {
    if (filter) {
      setSelectedCountries(filter.countries || []);
      setSelectedCompanies(filter.companies || []);
    }
  }, [open, filter]);

  const onClear = () => {
    setSelectedCountries([]);
  };

  const handleSubmit = () => {
    onSubmit({
      countries: selectedCountries,
      companies: selectedCompanies,
    });
  }

  const countries = useMemo(() => {
    if (currentUser.role === userRoles.COUNTRY_ADMIN.name) {
      return currentUser?.administrationCountries || [];
    }

    const result = [];
    companies.forEach((comp) => {
      comp?.countries.forEach((country) => {
        if (!result.includes(country)) {
          result.push(country);
        }
      });
    });

    return result;
  }, [companies, currentUser]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Filter Hospitals"
      subtitle="Apply filters to find specific hospitals"
      submitText="Submit"
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' }, maxWidth: '560px' }}>
        {currentUser.role === userRoles.GLOBAL_ADMIN.name && (
          <Box>
            <Autocomplete
              value={selectedCompanies}
              onChange={setSelectedCompanies}
              getOptionLabel={(option) => option.name}
              options={companies}
              label="Company"
              multiple
            />
          </Box>
        )}
        <Box sx={{ mt: currentUser.role === userRoles.GLOBAL_ADMIN.name ? 1 : 0 }}>
          <Autocomplete
            value={selectedCountries}
            onChange={setSelectedCountries}
            options={countries}
            label="Country"
            multiple
          />
        </Box>
        <Button
          sx={{ mt: 2 }}
          text="Clear Filters"
          icon={<FilterAltOffOutlinedIcon />}
          onClick={onClear}
          type='secondary'
        />
      </Box>
    </Drawer>
  );
};

export default FilterHospitalsModal;
